import React, { memo } from 'react';
import { RoadmapsUpsell } from '@jira/growth__jira-roadmap-in-nav/src/RoadmapsUpsell.tsx';

import { useIsCrossProjectViewsEnabled } from '@jira/polaris__lib-entitlement-utils/src/index.tsx';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useConfigurableMessageAndIconMap } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/controllers/use-configurable-message-and-icon-map/index.tsx';
import {
	L1_MENU_ID,
	type Nav4DragAndDropMenuItemProps,
} from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import type { Nav4RoadmapsProps } from './ui/roadmaps/index.tsx';
import { PACKAGE_NAME } from './common/constants.tsx';
import { Nav4Roadmaps } from './index.tsx';

const RoadmapsUpsellItem: React.FC<Nav4DragAndDropMenuItemProps> = memo((props) => {
	const { formattedMessage, icon } = useConfigurableMessageAndIconMap(L1_MENU_ID.ROADMAPS);

	return <RoadmapsUpsell formattedMessage={formattedMessage} icon={icon} {...props} />;
});

export const Nav4RoadmapsNew: React.FC<Nav4RoadmapsProps> = memo((props) => {
	const { isExpanded, ...dndProps } = props;
	const isCrossProjectViewsEnabled = useIsCrossProjectViewsEnabled();

	if (!isCrossProjectViewsEnabled) {
		const actualProps = fg('navx-global-side-nav') ? dndProps : {};

		return (
			<SidebarBoundary
				id="nav4.sidebar.roadmaps.upsell"
				packageName={PACKAGE_NAME}
				teamName="JPD - Juno"
				ufoName="nav4-sidebar-roadmaps-upsell"
			>
				<RoadmapsUpsellItem {...actualProps} />
			</SidebarBoundary>
		);
	}

	return <Nav4Roadmaps isExpanded={isExpanded} {...dndProps} />;
});
